// Shared by CRM screens and the dark navigation, so their surfaces stay consistent.
export const crmDarkColors = {
  background: "#101824", surface: "#182332", inset: "#121D2B", raised: "#213047",
  text: "#EDF3FA", muted: "#A9B8CB", border: "#2C3B50", accent: "#82B1FF",
  accentSoft: "#233A5E", hover: "#1E2E44", selected: "#253C5B", stars: "#F4C56A",
  emptyStars: "#8294AC", focus: "#A5C8FF"
};

export const crmLightColors = {
  background: "#F4F7FC", surface: "#FFFFFF", inset: "#F8FAFD", raised: "#ECF2FB",
  text: "#18273D", muted: "#60718A", border: "#DCE4F0", accent: "#245AC7",
  accentSoft: "#EAF1FF", hover: "#F0F5FE", selected: "#E5EEFD", stars: "#9B6209",
  emptyStars: "#7B8CA3", focus: "#245AC7"
};

export const githubDarkColors = {
  background: "#0D1117", surface: "#010409", inset: "#161B22", raised: "#21262D",
  text: "#F0F6FC", muted: "#8B949E", border: "#30363D", accent: "#58A6FF",
  accentSoft: "#1C2D41", hover: "#21262D", selected: "#233449", stars: "#D29922",
  emptyStars: "#6E7681", focus: "#79C0FF"
};
export const githubLightColors = {
  background: "#F6F8FA", surface: "#FFFFFF", inset: "#F6F8FA", raised: "#EAEEF2",
  text: "#1F2328", muted: "#59636E", border: "#D1D9E0", accent: "#0969DA",
  accentSoft: "#DDF4FF", hover: "#EAEEF2", selected: "#DDF4FF", stars: "#9A6700",
  emptyStars: "#818B98", focus: "#0550AE"
};
export const uiPalettes = [
  { id: "cchat", name: "Padrão Cchat", light: crmLightColors, dark: crmDarkColors },
  { id: "github", name: "GitHub", light: githubLightColors, dark: githubDarkColors }
];
export const normalizeUiPalette = value => value === "github" ? "github" : "cchat";
// Resolve from the theme instance; never share mutable company state between themes.
export function getCrmColors(theme = {}, mode = theme.palette?.type || theme.mode || "light") {
  return uiPalettes[normalizeUiPalette(theme.uiPalette) === "github" ? 1 : 0][mode === "dark" ? "dark" : "light"];
}
// Cards are brighter than their containing panels in GitHub dark; keep the other presets unchanged.
export function getCrmCardColor(theme) {
  const colors = getCrmColors(theme);
  return theme.uiPalette === "github" && theme.palette.type === "dark" ? colors.inset : colors.surface;
}
export function withUiPalette(options, value) {
  if (normalizeUiPalette(value) === "cchat") return options;
  const colors = getCrmColors({ ...options, uiPalette: "github" });
  return {
    ...options, uiPalette: "github",
    palette: {
      ...options.palette,
      primary: { main: colors.accent, contrastText: options.palette.type === "dark" ? colors.background : "#FFFFFF" },
      background: { default: colors.background, paper: colors.surface },
      text: { primary: colors.text, secondary: colors.muted },
      divider: colors.border,
      action: { ...options.palette.action, active: colors.text, hover: colors.hover, selected: colors.selected, focus: colors.accentSoft },
      textPrimary: colors.text, borderPrimary: colors.border, fontColor: colors.text,
      tabHeaderBackground: colors.surface, optionsBackground: colors.inset,
      fancyBackground: colors.background, total: colors.surface, messageIcons: colors.text,
      inputBackground: colors.inset, barraSuperior: colors.accent
    },
    scrollbarStyles: { ...options.scrollbarStyles, "&::-webkit-scrollbar-thumb": { backgroundColor: colors.border, borderRadius: 8 } },
    scrollbarStylesSoft: { ...options.scrollbarStylesSoft, "&::-webkit-scrollbar-thumb": { backgroundColor: colors.border, borderRadius: 8 } }
  };
}
